import { render, staticRenderFns } from "./vip-explain.vue?vue&type=template&id=5babc2c8&scoped=true&"
var script = {}
import style0 from "./vip-explain.vue?vue&type=style&index=0&id=5babc2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5babc2c8",
  null
  
)

export default component.exports